module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/powerButtonRed.cf2ec03e.svg";